import type { FunctionComponent } from 'react';
import React from 'react';
import { ApolloProvider as AP } from '@apollo/client';
import { client } from './client';

export const ApolloProvider: FunctionComponent = ({ children }) => (
  <AP client={client}>{children}</AP>
);
